module.exports = __webpack_public_path__ + "img/model2.a08d4d0a.png";